module.exports = __webpack_public_path__ + "img/circle.2112652c.gif";